import React, { memo, useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';

// eslint-disable-next-line react/display-name
const SvgIconDeactivate = memo(
    ({ disabled = false, onClick, style, ...props }) => {
        const ref = useRef(null);

        return (
            <svg
                ref={ref}
                width={50}
                height={50}
                viewBox='0 0 50 50'
                fill={disabled ? '#cccccc' : ''}
                style={{
                    cursor: disabled ? 'default' : 'pointer',
                    ...style
                }}
                {...buildSvgEvents(ref, disabled, onClick)}
                {...props}
            >
                <path d='M26.03 50h-2.04c-.07-.01-.15-.03-.22-.04-1.01-.11-2.03-.17-3.04-.34-3.59-.61-6.89-1.96-9.89-4.04C2.96 40.14-1.12 30.76.28 21.36c.52-3.46 1.65-6.69 3.56-9.62C8.43 4.7 14.93.79 23.31.08c3.07-.26 6.09.11 9.03 1.04 5.9 1.86 10.51 5.41 13.83 10.62 2.08 3.26 3.29 6.84 3.69 10.69.05.52.09 1.05.14 1.57v2.04c-.01.1-.04.2-.04.3a23.32 23.32 0 01-.75 4.92c-1.56 5.86-4.8 10.58-9.72 14.12-3.55 2.55-7.51 4.03-11.86 4.49-.54.04-1.07.08-1.6.13zm14.89-12.45c5.91-7.15 6.4-19.23-1.83-27.16-8.15-7.86-19.9-6.92-26.64-1.29 9.49 9.48 18.98 18.97 28.47 28.45zM9.1 12.45c-5.89 7.07-6.47 19.22 1.87 27.22 8.16 7.83 19.93 6.86 26.59 1.25-9.48-9.5-18.97-18.99-28.46-28.47z' />
            </svg>
        );
    }
);

export default SvgIconDeactivate;
